import { render, staticRenderFns } from "./GettingStartedModal.vue?vue&type=template&id=f75e4022&scoped=true"
import script from "./GettingStartedModal.vue?vue&type=script&lang=ts"
export * from "./GettingStartedModal.vue?vue&type=script&lang=ts"
import style0 from "./GettingStartedModal.vue?vue&type=style&index=0&id=f75e4022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75e4022",
  null
  
)

export default component.exports